import { ROUTES } from "@/constants/routes";

/** Matches org names like `Test Corp [Demo xx00]` or `criscocorp [Demo xx01]`. */
export const DEMO_KIT_ORG_NAME_SUFFIX_PATTERN = /\s\[Demo [A-Za-z0-9]{4}\]$/;

/** Org type assigned to demo kit organizations. */
export const DEMO_ORG_TYPE = "DEMO";

export type DemoKitOrgIdentity = {
  name?: string;
  orgType?: string;
};

export const isDemoKitOrganization = (orgName: string): boolean =>
  DEMO_KIT_ORG_NAME_SUFFIX_PATTERN.test(orgName.trim());

export const isDemoKitOrgRecord = (
  org?: DemoKitOrgIdentity | null,
): boolean => {
  if (!org) {
    return false;
  }

  if (org.orgType?.trim().toUpperCase() === DEMO_ORG_TYPE) {
    return true;
  }

  return Boolean(org.name && isDemoKitOrganization(org.name));
};

const DEMO_KIT_RESTRICTED_PATH_PREFIXES = [
  ROUTES.ASSETS,
  ROUTES.REPORTS,
  ROUTES.PAIRING,
] as const;

export const isDemoKitRestrictedPath = (pathname: string): boolean =>
  DEMO_KIT_RESTRICTED_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
